import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create an Axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});

// Add a request interceptor to include the token dynamically
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Retrieve token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ---------------------- Usuario ----------------------
export const getUsers = async () => apiClient.get(`/usuario`);
export const getUsuarioByUser_Id = async (id) => apiClient.get(`/usuario/${id}`);
export const updateUser = async (id, userData) => apiClient.put(`/usuario/${id}`, userData);
export const bloquearUsuarioBy_Id = async (id) => apiClient.put(`/usuario/bloquear/${id}`);
export const desbloquearUsuarioBy_Id = async (id) => apiClient.put(`/usuario/desbloquear/${id}`);
export const changePassword = async (passwordData) => apiClient.put(`/usuario/cambiar-contrasena`, passwordData);

// ---------------------- Incidente ----------------------
export const getIncidentes = async () => apiClient.get(`/incidente`);
export const getIncidentesActivos = async () => apiClient.get(`/incidente_activo`);
export const getIncidenteById = async (id) => apiClient.get(`/incidente/${id}`);
export const createIncidente = async (data) => apiClient.post(`/incidente`, data);
export const updateIncidenteById = async (id, data) => apiClient.put(`/incidente/${id}`, data);
export const openIncidenteById = async (id, data) => apiClient.put(`/incidente/open/${id}`, data);
export const deleteIncidenteById = async (id) => apiClient.delete(`/incidente/${id}`);
export const getIncidentesbyProducto = async (id) => apiClient.get(`/incidente_by_producto/${id}`);

// ----------------------Tipo Incidente ----------------------
export const getTipoIncidentes = async () => apiClient.get(`/tipo_incidente`);
export const getTipoIncidenteById = async (id) => apiClient.get(`/tipo_incidente/${id}`);
export const createTipoIncidente = async (data) => apiClient.post(`/tipo_incidente`, data);
export const updateTipoIncidenteById = async (id, data) => apiClient.put(`/tipo_incidente/${id}`, data);
export const deleteTipoIncidenteById = async (id) => apiClient.delete(`/tipo_incidente/${id}`);

// ----------------------Tipo Ubicacion ----------------------
export const getTipoUbicacion = async () => apiClient.get(`/tipo_ubicacion`);
export const getTipoUbicacionById = async (id) => apiClient.get(`/tipo_ubicacion/${id}`);
export const createTipoUbicacion = async (data) => apiClient.post(`/tipo_ubicacion`, data);
export const updateTipoUbicacionById = async (id, data) => apiClient.put(`/tipo_ubicacion/${id}`, data);
export const deleteTipoUbicacionById = async (id) => apiClient.delete(`/tipo_ubicacion/${id}`);

// ---------------------- Producto ----------------------
export const getProductos = async () => apiClient.get(`/producto`);
export const getProductoById = async (id) => apiClient.get(`/producto/${id}`);
export const deleteProductoById = async (id) => apiClient.delete(`/producto/${id}`);
export const getProductosbyIncidente = async (id) => apiClient.get(`/producto_by_incidente/${id}`);
export const getProductosbyEmpleado = async (id) => apiClient.get(`/get_reporte_empleado/${id}`);
export const getReporteEspecifico = async (mes, anio) => apiClient.get(`/get_reporte_especifico?mes=${mes}&anio=${anio}`);
export const getReportesActual = async () => apiClient.get(`/get_reporte_actual`);

// ---------------------- proyecto ----------------------
export const getProyectos = async () => apiClient.get(`/proyecto`);
export const getProyectoById = async (id) => apiClient.get(`/proyecto/${id}`);
export const deleteProyectoById = async (id) => apiClient.delete(`/proyecto/${id}`);
export const getProyectosbyIncidente = async (id) => apiClient.get(`/proyecto_by_incidente/${id}`);
export const createProyecto = async (data) => apiClient.post(`/proyecto`, data);

// ---------------------- concepto ----------------------
export const getConceptos = async () => apiClient.get(`/concepto`);
export const getConceptoById = async (id) => apiClient.get(`/concepto/${id}`);
export const deleteConceptoById = async (id) => apiClient.delete(`/concepto/${id}`);
export const getConceptosbyIncidente = async (id) => apiClient.get(`/concepto_by_incidente/${id}`);
export const createConcepto = async (data) => apiClient.post(`/concepto`, data);

// ---------------------- Material ----------------------
export const getMaterial = async () => apiClient.get(`/material`);
export const getMaterialById = async (id) => apiClient.get(`/material/${id}`);
export const createMaterial = async (data) => apiClient.post(`/material`, data);
export const updateMaterialById = async (id, data) => apiClient.put(`/material/${id}`, data);
export const deleteMaterialById = async (id) => apiClient.delete(`/material/${id}`);

// ---------------------- Marca ----------------------
export const getMarcas = async () => apiClient.get(`/marca`);
export const getMarcaById = async (id) => apiClient.get(`/marca/${id}`);
export const createMarca = async (data) => apiClient.post(`/marca`, data);
export const updateMarcaById = async (id, data) => apiClient.put(`/marca/${id}`, data);
export const deleteMarcaById = async (id) => apiClient.delete(`/marca/${id}`);

// ---------------------- Ticket ----------------------
export const getTickets = async () => apiClient.get(`/ticket`);
export const getTicketById = async (id) => apiClient.get(`/ticket/${id}`);
export const createTicket = async (data) => apiClient.post(`/ticket`, data);
export const updateTicketById = async (id, data) => apiClient.put(`/ticket/${id}`, data);
export const deleteTicketById = async (id) => apiClient.delete(`/ticket/${id}`);

// ---------------------- Familia ----------------------
export const getFamilias = async () => apiClient.get(`/familia`);
export const getFamiliaById = async (id) => apiClient.get(`/familia/${id}`);
export const createFamilia = async (data) => apiClient.post(`/familia`, data);
export const updateFamiliaById = async (id, data) => apiClient.put(`/familia/${id}`, data);
export const deleteFamiliaById = async (id) => apiClient.delete(`/familia/${id}`);

// ---------------------- Factura ----------------------
export const getFacturas = async () => apiClient.get(`/factura`);
export const getFacturaById = async (id) => apiClient.get(`/factura/${id}`);
export const createFactura = async (data) => apiClient.post(`/factura`, data);
export const updateFacturaById = async (id, data) => apiClient.put(`/factura/${id}`, data);
export const deleteFacturaById = async (id) => apiClient.delete(`/factura/${id}`);

// ---------------------- ClienteProveedor ----------------------
export const getClienteProveedor = async () => apiClient.get(`/cliente_proveedor`);
export const getClienteProveedorById = async (id) => apiClient.get(`/cliente_proveedor/${id}`);
export const createClienteProveedor = async (data) => apiClient.post(`/cliente_proveedor`, data);
export const updateClienteProveedorById = async (id, data) => apiClient.put(`/cliente_proveedor/${id}`, data);
export const deleteClienteProveedorById = async (id) => apiClient.delete(`/cliente_proveedor/${id}`);

// ---------------------- NM_Incidente_Producto ----------------------
export const getNMIncidenteProducto = async () => apiClient.get(`/nm_incidente_producto`);
export const getNMIncidenteProductoById = async (id) => apiClient.get(`/nm_incidente_producto/${id}`);
export const createNMIncidenteProducto = async (data) => apiClient.post(`/nm_incidente_producto`, data);
export const updateNMIncidenteProductoById = async (id, data) => apiClient.put(`/nm_incidente_producto/${id}`, data);
export const deleteNMIncidenteProductoById = async (id) => apiClient.delete(`/nm_incidente_producto/${id}`);


// ---------------------- usuario ----------------------
export const getUsuarios = async () => apiClient.get(`/usuario`);
export const getUsuarioById = async (id) => apiClient.get(`/usuario/${id}`);
export const createUsuario = async (data) => apiClient.post(`/usuario`, data);
export const updateUsuarioById = async (id, data) => apiClient.put(`/usuario/${id}`, data);
export const deleteUsuarioById = async (id) => apiClient.delete(`/usuario/${id}`);

// ---------------------- Empleado ----------------------
export const getEmpleados = async () => apiClient.get(`/empleado`);
export const getEmpleadoById = async (id) => apiClient.get(`/empleado/${id}`);
export const createEmpleado = async (data) => apiClient.post(`/empleado`, data);
export const updateEmpleadoById = async (id, data) => apiClient.put(`/empleado/${id}`, data);
export const deleteEmpleadoById = async (id) => apiClient.delete(`/empleado/${id}`);
export const getEmpleadoByUserId = async (id) => apiClient.get(`/empleado_by_user/${id}`);

// ---------------------- Ubicacion ----------------------
export const getUbicacion = async () => apiClient.get(`/ubicacion`);
export const getUbicacionById = async (id) => apiClient.get(`/ubicacion/${id}`);
export const createUbicacion = async (data) => apiClient.post(`/ubicacion`, data);
export const updateUbicacionById = async (id, data) => apiClient.put(`/ubicacion/${id}`, data);
export const deleteUbicacionById = async (id) => apiClient.delete(`/ubicacion/${id}`);

// 🔹 Autenticación
export const loginUser = async ({ username, contrasena, tipo_usuario }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, {
      username,
      contrasena,
      tipo_usuario,
    });
    if (response.status !== 200) {
      throw new Error("Invalid credentials or user not found.");
    }

    return response.data; // Should return { user, token }
  } catch (error) {
    throw error;
  }
};

export const createUser = async (formData) => {
  const response = await apiClient.post(`/usuario`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct handling of formData
    },
  });

  if (!response.status === 200) {
    throw new Error("Error al crear usuario");
  }

  return response.data;
};
export const createProducto = async (formData) => {
  const response = await apiClient.post(`/producto`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct handling of formData
      "Accept": "application/json",
    },
  });

  if (!response.status === 200) {
    throw new Error("Error al crear producto");
  }

  return response.data;
};

export const updateProductoById = async (id, formData) => {
  const response = await apiClient.put(`/producto/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct handling of formData
      "Accept": "application/json",
    },
  });

  if (response.status !== 200) {
    throw new Error("Error al actualizar producto");
  }

  return response.data;
};